import { render, staticRenderFns } from "./arena-status-indicator.vue?vue&type=template&id=1f01409e&scoped=true"
import script from "./arena-status-indicator.vue?vue&type=script&lang=js"
export * from "./arena-status-indicator.vue?vue&type=script&lang=js"
import style0 from "./arena-status-indicator.vue?vue&type=style&index=0&id=1f01409e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f01409e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f01409e')) {
      api.createRecord('1f01409e', component.options)
    } else {
      api.reload('1f01409e', component.options)
    }
    module.hot.accept("./arena-status-indicator.vue?vue&type=template&id=1f01409e&scoped=true", function () {
      api.rerender('1f01409e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bet-panel/arena-status-indicator.vue"
export default component.exports